import IBaseComponent from '@components/FormFlow/Interfaces/Base/IBaseComponent';
import IDrawComponent from '@components/FormFlow/Interfaces/FormflowComponents/IDrawComponent';
import FormflowContext from '@components/FormFlow/Util/FormflowContext';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Button, Row } from 'antd';
import React from 'react';

import { InstructionTaskComponent } from '../TextInstructionComponent';

interface IDrawTaskComponentStateType {
  drawComponent: IBaseComponent;
  instructionTitle: string;
  required: boolean;
  description?: string;
  repeat: boolean;
  minRepeat: number;
  maxRepeat: number;
};

export class DrawComponent implements IDrawComponent {
  id: string;
  required: boolean;
  type: ComponentType;
  title: string;
  description?: string;
  repeat: boolean;
  minRepeat: number;
  maxRepeat: number;

  constructor(id: string = '') {
    this.id = id;
    this.required = false;
    this.type = ComponentType.DRAW;
    this.title = '';
    this.repeat = false;
    this.minRepeat = 0;
    this.maxRepeat = 999;
    return this;
  }
}

export default class DrawTaskComponent extends React.Component<IDrawComponent, IDrawTaskComponentStateType> {

  constructor(props: IDrawComponent) {
    super(props);
    this.state = {
      instructionTitle: this.props.title || '',
      description: this.props.description || undefined,
      required: this.props.required || false,
      repeat: this.props.repeat || false,
      minRepeat: this.props.minRepeat,
      maxRepeat: this.props.maxRepeat,
      drawComponent: {
        id: this.props.id,
        type: ComponentType.DRAW,
        title: this.props.title,
        description: this.props.description,
        required: this.props.required
      }
    };
  }

  //#region HANDLERS
  handleIntructionTitleChange = async (evt: any) => {
    this.setState({ instructionTitle: evt.target.value });
  }

  handleDescriptionChange = async (evt: any) => {
    this.setState({ description: evt.target.value });
  }

  handleRequiredChange = async (evt: any) => {
    this.setState({ required: evt.target.checked });
  }

  handleRepeatChange = async (evt: any) => {
    this.setState({ repeat: evt.target.checked });
  }
  handleRepeatMinChange = async (evt: any) => {
    this.setState({ minRepeat: evt });
  }
  handleRepeatMaxChange = async (evt: any) => {
    this.setState({ maxRepeat: evt });
  }

  //#endregion

  onSubmitDrawComponent(updateFormflowWithComponent: (component: IBaseComponent) => void) {
    const newDrawDataComponent: IDrawComponent = {
      id: this.props.id,
      type: ComponentType.DRAW,
      title: this.state.instructionTitle,
      description: this.state.description,
      required: this.state.required,
      repeat: this.state.repeat,
      minRepeat: this.state.minRepeat,
      maxRepeat: this.state.maxRepeat
    }

    console.log('valor do create', newDrawDataComponent)
    updateFormflowWithComponent(newDrawDataComponent);
  }

  render() {

    const {
      instructionTitle,
      required,
      repeat
    } = this.state

    return (
      <div>
        <InstructionTaskComponent
          conditionsTaskComponents={true}
          inputDescriptionValue={this.props.description != undefined ? this.props.description : ''}
          visibleDescription={true}
          inputTitleValue={instructionTitle}
          repeatCheckedValue={repeat}
          requiredCheckedValue={required}
          onInputInstructionChange={() => this.handleIntructionTitleChange}
          onChangeDescription={() => this.handleDescriptionChange}
          onChangeRequiredCheckbox={() => this.handleRequiredChange}
          onChangeRepeatCheckbox={() => this.handleRepeatChange}
          onChangeRepeatMin={this.handleRepeatMinChange}
          onChangeRepeatMax={this.handleRepeatMaxChange}
          valueRepeatMin={this.state.minRepeat}
          valueRepeatMax={this.state.maxRepeat}
          titleComponent={I18n.l("formflow.components.drawComponent.titleDrawComponent")}
          descriptionComponent={I18n.l("formflow.components.drawComponent.descriptionDrawComponent")}
          exampleDescriptionComponent={I18n.l("formflow.components.drawComponent.exampleDescriptionDrawComponent")}
          checkboxtTaskPerform={true}
          titleCheckboxtTaskPerform={I18n.l("formflow.components.drawComponent.titleCheckboxtTaskPerformDrawComponent")}
          titleRepeatMin={I18n.l("formflow.components.drawComponent.titleRepeatMin")}
          titleRepeatMax={I18n.l("formflow.components.drawComponent.titleRepeatMax")}
        />

        <FormflowContext.Consumer>
          {({ destroyComponentModalWindow, updateFormflowWithComponent }) => (
            <div>
              <ButtonStyle>
                <Row type="flex" justify="end">
                  <Button className="button-cancel" type="primary" onClick={destroyComponentModalWindow} ghost>{I18n.l('common.cancel')}</Button>
                  <Button className="button-save" type="primary" disabled={instructionTitle.length === 0 || instructionTitle.length < 3 ? true : false} onClick={() => { this.onSubmitDrawComponent(updateFormflowWithComponent) }} >{I18n.l('common.save')}</Button>
                </Row>
              </ButtonStyle>
            </div>
          )}
        </FormflowContext.Consumer>
      </div>
    );
  }
}

//#region CSS
const ButtonStyle = styled.div`
    float:right;
    margin-top: 15vh;
    margin-right: 50px;
    
    .button-save{
        bottom: 5%;
        width: 6rem;
    }
    .button-cancel{
        bottom: 5%;
        width: 6rem;
        margin-left: -6.5rem;
    }
`;
//#endregion
